<template>
  <div class="wrap-dashboard">
    <div class="main-content">
      <div class="wrap-content">
        <div class="title-page">User</div>
        <div class="content">
          <button type="button" class="btn btn-light" v-b-modal.modal-1>Add</button>
          <table>
            <thead>
              <tr id="top">
                <th scope="col">No</th>
                <th scope="col">Name</th>
                <th scope="col">Username</th>
                <th scope="col">Email</th>
                <th scope="col">Role</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, i) in usersData" :key="i">
                <td data-label="No">{{ i + 1 }}</td>
                <td data-label="Name">{{ user.fullname }}</td>
                <td data-label="Username">{{ user.username }}</td>
                <td data-label="Email">{{ user.email }}</td>
                <td data-label="Role">{{ user.role }}</td>
                <td data-label="Status">{{ user.status }}</td>
                <td data-label="Action">
                  <button type="button" class="btn btn-outline-warning btn-sm mr-2" @click="openModal(user, 'modal-edit-password')">Edit</button>
                  <button type="button" class="btn btn-outline-danger btn-sm" @click="openModal(user, 'modal-block', 'blocked')" v-if="user.status == 'active'">
                    Block
                  </button>
                  <button type="button" class="btn btn-outline-success btn-sm" @click="openModal(user, 'modal-block', 'active')" v-else>Activate</button>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <b-pagination
            v-model="currentPage"
            :total-rows="lengthData"
            :per-page="perPage"
            @change="handlePageChange"
            aria-controls="new-table"
            first-number
            last-number
            v-show="lengthData > 10"
          ></b-pagination> -->
        </div>
        <b-modal id="modal-1" title="Add User" @ok="handleOk">
          <form>
            <div class="form-group">
              <label for="">Name</label>
              <input type="text" placeholder="input Name" class="form-input" v-model="formAddUser.fullname" />
            </div>
            <div class="form-group">
              <label for="">Username</label>
              <input type="text" placeholder="input username" class="form-input" v-model="formAddUser.username" />
            </div>
            <div class="form-group">
              <label for="">Phone Number</label>
              <input type="text" placeholder="input phonenumber" class="form-input" v-model="formAddUser.phonenumber" />
            </div>
            <div class="form-group">
              <label for="">Email</label>
              <input type="email" placeholder="input email" class="form-input" v-model="formAddUser.email" />
            </div>
            <div class="form-group">
              <label for="">Password</label>
              <input type="password" placeholder="input password" class="form-input" v-model="formAddUser.password" />
            </div>
            <div class="form-group">
              <label for="">Role</label>
              <select name="" id="" class="form-input" v-model="formAddUser.role_id">
                <option value="" selected disabled>Select Role</option>
                <option v-for="(role, i) in roles" :key="i" :value="role._id">{{ role.name }}</option>
              </select>
            </div>
          </form>
        </b-modal>
        <b-modal ref="modal-edit-password" no-stacking :title="'Change password ' + fullname">
          <form action="">
            <div class="form-group">
              <label for="">Change Password</label>
              <input :type="type" name="" id="" placeholder="input password" class="form-input" v-model="form.password" />
              <b-icon v-show="selected === false" icon="eye-fill" class="icon-eye" @click="(selected = true), (type = 'text')"></b-icon>
              <b-icon v-show="selected === true" icon="eye-slash-fill" class="icon-eye" @click="(selected = false), (type = 'password')"></b-icon>
            </div>
          </form>
          <template #modal-footer>
            <button class="btn btn-primer" @click="inputData">Submit</button>
          </template>
        </b-modal>

        <b-modal ref="modal-edit" title="Input Your Password">
          <div class="form-group">
            <label for="">Password</label>
            <input :type="type" placeholder="input password" class="form-input" v-model="form.user_password" />
            <b-icon v-show="selected === false" icon="eye-fill" class="icon-eye" @click="(selected = true), (type = 'text')"></b-icon>
            <b-icon v-show="selected === true" icon="eye-slash-fill" class="icon-eye" @click="(selected = false), (type = 'password')"></b-icon>
          </div>
          <template #modal-footer>
            <button class="btn btn-primer" @click="checkPassword">
              <b-spinner label="Loading..." v-if="isLoading" small></b-spinner>
              <span v-else>Submit</span>
            </button>
          </template>
        </b-modal>

        <b-modal ref="modal-block" title="Update User">
          <h6 class="text-center">Please confirm that you want to {{ status }} {{ fullname }}</h6>
          <div class="form-group">
            <label for="">Password</label>
            <input :type="type" class="form-input" placeholder="please input password" v-model="form.user_password" />
            <b-icon v-show="selected === false" icon="eye-fill" class="icon-eye" @click="(selected = true), (type = 'text')"></b-icon>
            <b-icon v-show="selected === true" icon="eye-slash-fill" class="icon-eye" @click="(selected = false), (type = 'password')"></b-icon>
            <!-- <div v-if="$v.form.password.$error"> -->
            <!-- <span v-if="!$v.form.password.required" class="error">Input File required</span> -->
            <!-- </div> -->
          </div>
          <template #modal-footer>
            <button type="button" class="btn btn-scondary">Cancel</button>
            <button type="button" class="btn btn-primer" @click="submitBlock">
              <b-spinner label="Loading..." v-if="isLoading" small></b-spinner>
              <span v-else>Submit</span>
            </button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import sha256 from "sha256";
export default {
  components: {},
  data() {
    return {
      usersData: [],
      isLoading: false,
      pageOfItems: [],
      currentPage: 1,
      perPage: 10,
      lengthData: 1,
      type: "password",
      selected: false,
      id: [],
      offset: 0,
      data: [],
      fullname: "",
      form: {
        user_password: "",
        id: "",
        password: "",
      },
      formAddUser: {
        email: "",
        username: "",
        phonenumber: "",
        fullname: "",
        password: "",
        role_id: "",
      },
      roles: [],
      status: "",
    };
  },
  validations: {
    form: {
      user_password: {
        required,
      },
    },
  },
  mounted() {
    this.getData(this.currentPage);
    axios.get("/v2/management/role/all").then((res) => {
      this.roles = res.data.data.roles;
    });
  },
  methods: {
    blockUser(data) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to Block " + data.fullname, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            console.log("setuju");
          } else {
            console.log("tidak setuju");
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    submitBlock() {
      this.isLoading = true;
      axios
        .put("/v2/management/user/update", {
          user_password: this.form.user_password,
          id: this.id,
          status: this.status,
        })
        .then((res) => {
          this.isLoading = false;
          if (res.data.data.status_code == "00") {
            this.$toast.success(res.data.message, {
              position: "top-center",
              timeout: 2000,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: false,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            setTimeout(function () {
              location.reload();
            }, 2000);
          }
        })
        .catch((err) => {
          let errorResponse = err.response.data.data;
          if (errorResponse.status_code == "1003")
            this.$toast.error(errorResponse.err_message, {
              position: "top-center",
              timeout: 2000,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: false,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          this.isLoading = false;
        });
    },
    openModal(data, modal, status) {
      this.id = data._id;
      this.fullname = data.fullname;
      this.status = status;
      this.$refs[modal].show();
    },
    checkPassword() {
      let data = {
        user_password: sha256(this.form.user_password),
        id: this.id,
        password: sha256(this.form.password),
      };
      this.isLoading = true;
      axios
        .put("/v2/management/user/update", data)
        .then((res) => {
          if (res.data.data.status_code == "00") {
            this.$toast.success(res.data.message, {
              position: "top-center",
              timeout: 2000,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: false,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            setTimeout(function () {
              location.reload();
            }, 2000);
          }
          this.isLoading = false;
        })
        .catch((err) => {
          let errorResponse = err.response.data.data;
          if (errorResponse.status_code == "1003")
            this.$toast.error(errorResponse.err_message, {
              position: "top-center",
              timeout: 2000,
              closeOnClick: true,
              pauseOnFocusLoss: false,
              pauseOnHover: false,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          this.isLoading = false;
        });
    },
    inputData() {
      if (this.form.password != "") {
        this.$refs["modal-edit"].show();
      }
    },
    handleOk(bvModal) {
      console.log(bvModal);
      axios.post("/v2/management/user", this.formAddUser).then((res) => {
        console.log(res);
      });
    },
    handlePageChange(value) {
      this.getData(value);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    getData(value) {
      let offset = (value - 1) * this.perPage;
      console.log(offset);
      axios.get("/v2/management/user/get").then((res) => {
        this.usersData = res.data.data.body;
        // this.lengthData = res.data.data.count;
      });
    },
  },
  computed: {
    rows() {
      return (this.currentPage - 1) * this.perPage;
    },
  },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.title-page {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 40px;
}

.wrap-content {
  width: 98%;
  height: 100%;
  margin: 0 auto;
  padding: 20px 25px;
}

.content {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: end;
}

.icon-trade {
  width: 25px;
}

.footer {
  background: var(--clr-primary);
  color: white;
  padding: 20px 47px;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  height: 62px;
}

.filter {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 12px;
  flex-wrap: wrap;
}

.wrap-input {
  margin-bottom: 10px;
}
.label-input {
  width: 108px;
}

.input-datalist {
  border-radius: 3px;
  border: 1px solid #a5a5a5a5;
  padding: 1.5px 5px;
}

.card {
  width: 314px;
  font-size: 14px;
  border-radius: 10px;
}

.card-header {
  padding: 1rem;
}

.buyer,
.seller,
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 12px;
  position: relative;
  left: 20px;
}

.title::before {
  content: "";
  position: absolute;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--clr-scondary);
  left: -17px;
  top: 3px;
}

.buyer {
  margin-bottom: 20px;
}

.content-right {
  text-align: right;
}

.amount {
  font-weight: bold;
}

.btn-primer {
  background: var(--clr-scondary);
  border: none;
  color: #ffffff;
  padding: 5px 25px;
  border-radius: 5px;
}

.btn-primer:hover {
  background-color: var(--clr-scondary-hover);
}

.form-group {
  position: relative;
}

.form-group label {
  font-weight: 600;
  width: 30%;
}

.form-input {
  width: 70%;
  border-radius: 5px;
  border: none;
  padding: 8px 13px;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
  font-size: 14px;
}

.form-input:focus {
  border-color: var(--clr-primary);
  outline: 0;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.icon-eye {
  cursor: pointer;
  position: absolute;
  font-size: 1.2rem;
  right: 1rem;
  top: 10px;
  color: #707070;
}
</style>
